import { joinCommaValues, splitCommaValues } from "./businessFilterPayload";
import { extractProviderHint } from "./businessDigestSetup";

const SENDER_CHIP_COLORS = {
  "google calendar": "#4285F4",
  "google meet": "#00897B",
  zoom: "#2d8cff",
  "microsoft teams": "#5b6cf0",
  webex: "#12b5a5",
};

/**
 * Dot color for a meeting-tool sender chip label.
 *
 * @example
 * getSenderChipColor("Zoom");
 * // "#2d8cff"
 */
export const getSenderChipColor = (label) =>
  SENDER_CHIP_COLORS[String(label || "").toLowerCase()] || "#8b93a7";

/**
 * Unique meeting-tool labels from sender patterns.
 *
 * @example
 * buildSenderPlatformChips("no-reply@zoom.us, no-reply@teams.microsoft.com");
 * // ["Zoom", "Microsoft Teams"]
 */
export const buildSenderPlatformChips = (senderPatterns) => {
  const seen = new Set();
  return splitCommaValues(senderPatterns)
    .map((pattern) => extractProviderHint(pattern))
    .filter((label) => {
      const key = String(label || "").toLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

/**
 * Remove all sender patterns that map to a platform chip label.
 *
 * @example
 * removeSenderPlatformChip("no-reply@zoom.us, no-reply@teams.microsoft.com", "Zoom");
 * // "no-reply@teams.microsoft.com"
 */
export const removeSenderPlatformChip = (senderPatterns, platformLabel) =>
  joinCommaValues(
    splitCommaValues(senderPatterns).filter(
      (pattern) => extractProviderHint(pattern) !== platformLabel
    )
  );

/**
 * Remove one subject keyword from a comma-separated list.
 *
 * @example
 * removeKeywordChip("meeting, agenda", "agenda");
 * // "meeting"
 */
export const removeKeywordChip = (subjectKeywords, keyword) =>
  joinCommaValues(splitCommaValues(subjectKeywords).filter((item) => item !== keyword));
